import { apiFetch } from './client'

export const healthApi = {
  getFull: (token: string) =>
    apiFetch<any>('/system/health', token),
}
